import { render, staticRenderFns } from "./TextPicker.vue?vue&type=template&id=006bde98&scoped=true&"
import script from "./TextPicker.vue?vue&type=script&lang=js&"
export * from "./TextPicker.vue?vue&type=script&lang=js&"
import style0 from "./TextPicker.vue?vue&type=style&index=0&id=006bde98&prod&lang=less&"
import style1 from "./TextPicker.vue?vue&type=style&index=1&id=006bde98&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006bde98",
  null
  
)

export default component.exports